module.exports = __webpack_public_path__ + "static/media/CartScreen.f9831bb4.png";